export const strFromArray = (arr: string[]): string => arr.join(' ')
